import http from 'http'

const state = {
}

const getters = {}

const mutations = {
}

const actions = {
  /**
   * 获取所有的sim充值订单
   */
  async getOrderData ({ commit, state }, options) {
    try {
      return await http.voucher.getOrderData(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
  /**
   * 根据订单号获取流量充值设备列表
   */
  async getdeviceLiseById ({ commit, state }, option) {
    try {
      return await http.voucher.getdeviceLiseById(option)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
  /**
   * 根据订单id导出设备的excel列表
   */
  async getExcelById ({ commit, state }, option) {
    try {
      return await http.voucher.getExcelById(option)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
  /**
   * 订单标记完成
   */
  async modifyMarkCompleted ({ commit, state }, options) {
    try {
      return await http.voucher.modifyMarkCompleted(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
    /**
   * 订单退款
   */
  async modifyRefund ({ commit, state }, options) {
    try {
      return await http.voucher.modifyRefund(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
    /**
   * 获取订单下设备信息
   */
  async getDeviceByOrderId ({ commit, state }, options) {
    try {
      return await http.voucher.getDeviceByOrderId(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
  /**
   * 获取所有商品
   */
  async getAllCommodity ({ commit, state }, options) {
    try {
      return await http.voucher.getAllCommodity(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
  /**
   * 添加商品
   */
  async addCommodity ({ commit, state }, options) {
    try {
      return await http.voucher.addCommodity(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
    /**
   * 修改商品
   */
  async editCommodity ({ commit, state }, options) {
    try {
      return await http.voucher.editCommodity(options)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
    /**
   * 根据id删除商品
   */
  async deleteCommodity ({ commit, state }, option) {
    try {
      return await http.voucher.deleteCommodity(option)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
    /**
   * 商品上架
   */
  async editStatusToEnable ({ commit, state }, option) {
    try {
      return await http.voucher.editStatusToEnable(option)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  },
    /**
   * 商品下架
   */
  async editStatusToDisable ({ commit, state }, option) {
    try {
      return await http.voucher.editStatusToDisable(option)
    } catch (e) {
      console.log(e)
      throw new Error(e)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
